export default __webpack_public_path__ + "static/pursue-428abe5ced4f63b26d59e647b5596d4b.png";